import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const Tabs = styled.div`
  ul {
    display: inline-flex;
    list-style-type: none;
    padding-left: 0px;
    margin: 0;
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;

    li {
      float: left;
      margin-bottom: 0px;
      text-transform: capitalize;

      a,
      span {
        color: #000;
        border-bottom: 2px solid transparent;
        text-decoration: none;
        font-size: 15px;
        padding: 10px 25px;
        margin: 0px;
        line-height: 42px;

        &:hover {
          color: ${({ theme }) => theme.body};
          // border-bottom: 2px solid ${({ theme }) => theme.body};
        }
      }
      a.active,
      span.active {
        color: ${({ theme }) => theme.body};
        border-bottom: 2px solid ${({ theme }) => theme.body};
      }
    }
  }

  &[disabled] {
    color: rgba(0, 0, 0, 0.26);
    cursor: not-allowed;

    &:hover {
      color: rgba(0, 0, 0, 0.26);
    }
  }

  &.condensed {
    background: ${(props) => (props.primary ? "palevioletred" : "white")};
    color: ${(props) => (props.primary ? "white" : "palevioletred")};
    color: white;
    background: ${({ theme }) => theme.body};
    border: 0;
  }
  &.outlined {
    color: ${({ theme }) => theme.body};
    background: transparent;
    border: 1px solid ${({ theme }) => theme.body};
  }

  &.linkable {
    color: ${({ theme }) => theme.body};
    background: transparent;
    border: 0px;
    padding: 5px;
  }

  &.text {
    background: transparent;
    padding: 6px 12px;
    border: 0px;
    color: ${({ theme }) => theme.body};

    &:hover {
      background: rgba(25, 118, 210, 0.04);
    }
  }
`;

function GTabs(props) {
  return (
    <Tabs>
      {!props.type ? (
        <ul>
          {props.routes.map((r, index) => (
            <li className="gg" key={index}>
              <Link
                to={r.link}
                className={r.title === props.active ? "active" : ""}
              >
                {r.title.replace("-", " ")}
              </Link>
            </li>
          ))}
        </ul>
      ) : props.type === "single" ? (
        <ul>
          {props.routes.map((r, index) => (
            <li className="gg" key={index}>
              <span
                onClick={(e) => {
                  if (props.onClick) {
                    props.onClick(r);
                  }
                  if (props.onSelectTab) {
                    props.onSelectTab(r);
                  }
                }}
                style={{ cursor: "pointer" }}
                className={r === props.active ? "active" : ""}
              >
                {r}
              </span>
            </li>
          ))}
        </ul>
      ) : (
        <ul>
          {props.routes.map((r, index) => (
            <li className="gg" key={index} style={{ display: "flex" }}>
              <span
                onClick={(e) => {
                  if (props.onClick) {
                    props.onClick(r[props.key_value]);
                  }
                  if (props.onSelectTab) {
                    props.onSelectTab(r[props.key_value]);
                  }
                }}
                style={{ cursor: "pointer", width: "max-content" }}
                className={r[props.key_value] === props.active ? "active" : ""}
              >
                {r[props.key_title]}
              </span>
            </li>
          ))}
        </ul>
      )}
    </Tabs>
  );
}

export default GTabs;
